import React from 'react';

// Khớp palette với /serve/ARServeStatuses
function getStatusStyle(row) {
    const s = row.serve_status;
    const r = row.requesting_type;
    if (s === 'Available') return { bg: '#97A5BEDC', label:'Trống'  };
    if (s === 'Reserved') return { bg: '#56417ee6', label: 'Đã đặt' };
    if (s === 'Unavailable') return { bg: '#717889eb', label: 'Không khả dụng' };
    if (s === 'Serving') {
        if (!r || r === 'None') return { bg: '#3b64a9d9', label:  'Có khách'};
        if (r === 'Checkin' || r === 'WaitingDelivery') return { bg: '#648d1bd9', label: 'Chờ phục vụ' };
        if (r === 'Accident') return { bg: '#982515d9', label: 'Sự cố' };
        return { bg: '#b27604d9', label: 'Yêu cầu' };
    }
    return { bg: '#94a3b8', label: s || '' };
}

export default function ServePlaceCard({ row, onClick, isActive }) {
    const style = getStatusStyle(row);
    const name = row.serve_place_name || '—';
    const type = row.serve_place_type;
    const desc = row.serve_desc;
    const note = row.serve_note;
    const placeTags = Array.isArray(row.serve_place_tags) ? row.serve_place_tags.slice(0, 3) : [];
    const serveTags = Array.isArray(row.serve_tags) ? row.serve_tags.slice(0, 3) : [];

    return (
        <div className={'spk-card' + (isActive ? ' spk-card--active' : '')} style={{ background: style.bg }} onClick={() => onClick && onClick(row)}>
            <div className="spk-card__head">
                <div className="spk-card__title">
                    {/* {type && <span className="spk-card__type">{type}</span>} */}
                    <span className="spk-card__name">{name}</span>
                </div>
              {style.label && (<span className="spk-card__status">{style.label}</span>)}  
            </div>
            {/* {(desc || note) && (
                <div className="spk-card__desc">
                    {desc && <span>{desc}</span>}
                    {desc && note && <span className="spk-card__sep">·</span>}
                    {note && <span className="spk-card__note">{note}</span>}
                </div>
            )} */}
            {(placeTags.length > 0 || serveTags.length > 0) && (
                <div className="spk-card__tags">
                    {placeTags.map((t) => (
                        <span key={'p-' + t} className="spk-card__tag" style={{ background: style.bg }}>
                            {t}
                        </span>
                    ))}
                    {serveTags.map((t) => (
                        <span key={'s-' + t} className="spk-card__tag spk-card__tag--serve" style={{ background: style.bg }}>
                            {t}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
}
